export default {
  "mainVegetable": "zelenina",
  "mainVegetable/01": "zelenina/lilek",
  "mainVegetable/02": "zelenina/chrest",
  "mainVegetable/03": "zelenina/avokado",
  "mainVegetable/04": "zelenina/repa",
  "mainVegetable/05": "zelenina/brokolice",
  "mainVegetable/06": "zelenina/mrkev",
  "mainVegetable/07": "zelenina/celer",
  "mainVegetable/08": "zelenina/houby",
  "mainVegetable/09": "zelenina/zeli",
  "mainVegetable/10": "zelenina/ruzickova-kapusta",
  "mainVegetable/11": "zelenina/cinske-zeli",
  "mainVegetable/12": "zelenina/kvetak",
  "mainVegetable/13": "zelenina/zelny-salat",
  "mainVegetable/14": "zelenina/okurka",
  "mainVegetable/15": "zelenina/cuketa",
  "mainVegetable/16": "zelenina/cekanka",
  "mainVegetable/17": "zelenina/spenat",
  "mainVegetable/18": "zelenina/fazole-fava",
  "mainVegetable/19": "zelenina/fazole-francouzske",
  "mainVegetable/20": "zelenina/fazole",
  "mainVegetable/21": "zelenina/fazole-suche",
  "mainVegetable/22": "zelenina/fazole-zelene",
  "mainVegetable/23": "zelenina/cocka",
  "mainVegetable/24": "zelenina/zeleninova-smes",
  "mainVegetable/25": "zelenina/kukurice",
  "mainVegetable/26": "zelenina/salatovy-mix",
  "mainVegetable/27": "zelenina/brukev",
  "mainVegetable/28": "zelenina/cibule",
  "mainVegetable/29": "zelenina/soja",
  "mainVegetable/30": "zelenina/paprika",
  "mainVegetable/31": "zelenina/brambory",
  "mainVegetable/32": "zelenina/klicky-sojovych-bobu",
  "mainVegetable/33": "zelenina/redkvicky",
  "mainVegetable/34": "zelenina/salat-dubovy-listovy",
  "mainVegetable/35": "zelenina/salat-kudrnaty",
  "mainVegetable/36": "zelenina/salat-ledovy",
  "mainVegetable/37": "zelenina/salat-bramborovy",
  "mainVegetable/38": "zelenina/salat-ryzovy",
  "mainVegetable/39": "zelenina/salat-rimsky",
  "mainVegetable/40": "zelenina/zelene-vyhonky",
  "mainVegetable/41": "zelenina/salat",
  "mainVegetable/42": "zelenina/kozlicek-polni",
  "mainVegetable/43": "zelenina/rukola",
  "mainVegetable/44": "zelenina/cerny-koren",
  "mainVegetable/45": "zelenina/tabouleh",
  "mainVegetable/46": "zelenina/rajce",
  "mainVegetable/47": "zelenina/fazole-maslove",
  "mainVegetable/48": "zelenina/cizrna",
  "mainVegetable/49": "zelenina/porek",
  "mainVegetable/50": "zelenina/dyne",
  "mainVegetable/51": "zelenina/fazole-cervene",
  "mainVegetable/52": "zelenina/jablko",
  "mainVegetable/53": "zelenina/kastan",
  "mainVegetable/54": "zelenina/svestka",
  "mainVegetable/55": "zelenina/giardiniera",
  "mainVegetable/56": "zelenina/cerne-olivy",
  "mainVegetable/57": "zelenina/artycok",
  "mainVegetable/58": "zelenina/paprika-cervena",
  "mainVegetable/59": "zelenina/fazolka-zelena",
  "mainVegetable/60": "zelenina/jarni-zelenina",
  "mainVegetable/61": "zelenina/ratatouille",
  "mainVegetable/62": "zelenina/kuskus",
  "mainVegetable/63": "zelenina/tazin",
  "mainVegetable/64": "zelenina/kari-zelenina",
  "mainVegetable/65": "zelenina/hrachove-salky",
  "mainVegetable/66": "zelenina",
  "mainVegetable/67": "zelenina/cocka-koralova",
  "mainVegetable/68": "zelenina/quinoa",
  "mainVegetable/69": "zelenina/psenice-spaldova",
  "mainVegetable/70": "zelenina/bulgur",
  "mainVegetable/71": "zelenina/zeli-cervene",
  "mainVegetable/72": "zelenina/kapusta-kaderava",
  "mainVegetable/73": "zelenina/kerblik",
  "mainVegetable/74": "zelenina/zrni-a-semena",
  "mainVegetable/75": "zelenina/lusteniny",
  "mainVegetable/76": "zelenina/smldinec",
  "mainVegetable/77": "zelenina/tykev",
  "mainVegetable/78": "zelenina/stovik",
  "mainVegetable/79": "zelenina/fazole",
  "mainVegetable/80": "zelenina/hrachova-mrkev",
  "mainVegetable/81": "zelenina/hrasek",
  "mainVegetable/82": "zelenina/edamame",
  "mainVegetable/83": "zelenina/jecmen",
  "mainVegetable/84": "zelenina/salatovy-mix",
  "mainVegetable/85": "zelenina/cekanka-cukrova",
  "mainVegetable/86": "zelenina/kozlicek-polni",
  "mainVegetable/87": "zelenina/spenat-baby",
  "mainVegetable/88": "zelenina/salat-batavia",
  "mainVegetable/89": "zelenina/mangold",
  "mainVegetable/90": "zelenina",
  "mainVegetable/91": "zelenina",
  "mainVegetable/92": "zelenina",
  "mainVegetable/93": "zelenina",
  "mainVegetable/94": "zelenina",
  "mainVegetable/95": "zelenina",
  "mainVegetable/96": "zelenina",
  "mainVegetable/97": "zelenina",
  "mainVegetable/98": "zelenina",
  "productRange": "rozsah",
  "productRange/4G_BIO": "rozsah",
  "productRange/4G_SRP": "rozsah",
  "productRange/CAN_A_POEL": "rozsah",
  "productRange/CAN_SEC_BI": "rozsah",
  "productRange/CAN_SEC_CO": "rozsah",
  "productRange/CAN_SEC_CU": "rozsah",
  "productRange/CAN_SEC_NA": "rozsah",
  "productRange/CAN_VAPEUR": "rozsah",
  "productRange/CAN_VEG_SA": "rozsah",
  "productRange/CAN_VEG_SR": "rozsah",
  "productRange/CLASSICVEG": "rozsah",
  "productRange/COLDVEGE": "rozsah",
  "productRange/COOKMUSH": "rozsah",
  "productRange/CRUDITES": "rozsah",
  "productRange/DE_NOS_PRO": "rozsah",
  "productRange/DOYMUSHACC": "rozsah",
  "productRange/DOYMUSHAPE": "rozsah",
  "productRange/DRYVEGE": "rozsah",
  "productRange/FROZENVEGE": "rozsah",
  "productRange/FRZ_ASTUCE": "rozsah",
  "productRange/FRZ_GRATIN": "rozsah",
  "productRange/FRZ_KELLO": "rozsah",
  "productRange/FRZ_LEG_CO": "rozsah",
  "productRange/FRZ_PUREES": "rozsah",
  "productRange/FRZ_VEG_BI": "rozsah",
  "productRange/FRZ_VEG_SR": "rozsah",
  "productRange/INDFROZVEG": "rozsah",
  "productRange/JEUNES_POU": "rozsah",
  "productRange/LAITUES": "rozsah",
  "productRange/LOOP": "rozsah",
  "productRange/LUNCH_BOWL": "rozsah",
  "productRange/MACHE_BASE": "rozsah",
  "productRange/MEL_LAITUE": "rozsah",
  "productRange/MUSHNATEMI": "rozsah",
  "productRange/MUSHNATENT": "rozsah",
  "productRange/MUSHNATEPA": "rozsah",
  "productRange/MUSHNATMIN": "rozsah",
  "productRange/MUSHROOMS": "rozsah",
  "productRange/SUNVEGE": "rozsah",
  "productRange/TRAIT_CRUD": "rozsah",
  "productRange/TRAIT_TABO": "rozsah",
  "productRange/TUS_RECETA": "rozsah",
  "productRange/WORLDVEGE": "rozsah",
  "productRange/PREPARED_VEG": "rozsah",
  "productRange/BEAN_SAUCE": "rozsah/bon-menu",
  "productRange/BEANS": "rozsah",
  "productRange/BIO": "rozsah",
  "productRange/BOND_KIDS": "rozsah",
  "productRange/CAN_BIO": "rozsah",
  "productRange/CAN_SEC_PR": "rozsah",
  "productRange/CARTA_DELL": "rozsah",
  "productRange/CAN_PETITS": "rozsah",
  "productRange/CAN_BOCAL": "rozsah",
  "productRange/CEREAL_CAN": "rozsah",
  "productRange/CEREAL_FRZ": "rozsah",
  "productRange/CEREALI": "rozsah",
  "productRange/CEREALLEGR": "rozsah",
  "productRange/COCCOLE": "rozsah",
  "productRange/CORN": "rozsah/zlata-kukurice",
  "productRange/CREATIF": "rozsah/creatif",
  "productRange/FRANCAIS": "rozsah",
  "productRange/FRZ_FRY_MI": "rozsah",
  "productRange/FRZ_MELANG": "rozsah",
  "productRange/FRZ_POELEE": "rozsah",
  "productRange/INSALATE_D": "rozsah",
  "productRange/INSALATONA": "rozsah",
  "productRange/LE_REGIONA": "rozsah",
  "productRange/LEGUMIO": "rozsah/legumio",
  "productRange/MIXES_CORN": "rozsah",
  "productRange/MONO_VEGE": "rozsah",
  "productRange/MUSHROOMS  ": "rozsah/zampiony",
  "productRange/NATURA_IN": "rozsah",
  "productRange/OTHER_VEG": "rozsah/ostatni",
  "productRange/PEAS": "rozsah/hrasek",
  "productRange/READY_FROZ": "rozsah/hotova-jidla",
  "productRange/SOUPS": "rozsah/polevkove-smesi",
  "productRange/SPINACH": "rozsah",
  "productRange/STEAM_CAN": "rozsah/vapeur",
  "productRange/STEAM_FRZ": "rozsah",
  "productRange/STEAM_MIX": "rozsah",
  "productRange/STUZZICHIA": "rozsah",
  "productRange/TOUCHE": "rozsah/mini",
  "productRange/TRAIT_SAL": "rozsah",
  "productRange/TUS_RECETA ": "rozsah",
  "productRange/VEG_TO_FRY": "rozsah",
  "productRange/VEGGIE": "rozsah",
  "productRange/FRZ_JUSTEA": "rozsah",
  "productRange/SALABIS": "rozsah",
  "productRange/BON_SENGAG": "rozsah",
  "productRange/CROUSTIS": "rozsah",
  "season": "sezona",
  "season/1": "sezona/leto",
  "season/2": "sezona/podzim",
  "season/3": "sezona/zima",
  "season/4": "sezona/jaro",
  "season/5": "sezona",
  "technologie": "technologie",
  "technologie/AC01": "technologie/sterilizovane",
  "technologie/AD01": "technologie/zmrazene",
  "technologie/AG01": "technologie/cerstve",
  "technologie/AT01": "technologie",
  "recipeDish": "typ-pokrmu",
  "recipeDish/ACC": "typ-pokrmu/mezi-chody",
  "recipeDish/APE": "typ-pokrmu/aperitiv",
  "recipeDish/DES": "typ-pokrmu/dezert",
  "recipeDish/ENT": "typ-pokrmu/predkrm",
  "recipeDish/PLAT": "typ-pokrmu/hlavni-jidlo",
  "recipeDish/SAL": "typ-pokrmu/salat",
  "recipeDish/SNA": "typ-pokrmu/svacina",
  "recipeDish/PDE": "typ-pokrmu/snidane",
  "recipeDish/DEJ": "typ-pokrmu/obed",
  "recipeDish/TRA": "typ-pokrmu/tradicni",
  "recipeDish/GOU": "typ-pokrmu/delikatesa",
  "recipeDish/ETH": "typ-pokrmu/kulturni",
  "recipeDish/FCH": "typ-pokrmu/pro-deti",
  "recipeDish/SOU": "typ-pokrmu",
  "pred-recipeTimingCook-facet": "doba-vareni",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "doba-vareni/0-15-minut",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "doba-vareni/15-30-minut",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "doba-vareni/30-45-minut",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "doba-vareni/45-minut",
  "pred-recipeTimingPreparation-facet": "dobra-pripravy",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "dobra-pripravy/0-15-minut",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "dobra-pripravy/15-30-minut",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "dobra-pripravy/30-45-minut",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "dobra-pripravy/45-minut",
  "pred-recipeCost-Facet": "rozpocet",
  "pred-recipeCost-Facet/petit": "rozpocet/levne",
  "pred-recipeCost-Facet/moyen": "rozpocet/drazsi",
  "pred-recipeCost-Facet/grand": "rozpocet/drahe",
  "recipeDifficulty": "slozitost",
  "recipeDifficulty/1": "slozitost/jednoduche",
  "recipeDifficulty/2": "slozitost/stredne-pokrocile",
  "recipeDifficulty/3": "slozitost/narocne",
  "recipeDishNumber": "pocet-hostu",
  "recipeDishNumber/1": "pocet-hostu/1",
  "recipeDishNumber/2": "pocet-hostu/2",
  "recipeDishNumber/3": "pocet-hostu/3",
  "recipeDishNumber/4": "pocet-hostu/4",
  "recipeDishNumber/5": "pocet-hostu/5",
  "recipeDishNumber/6": "pocet-hostu/6",
  "recipeDishNumber/7": "pocet-hostu/7",
  "recipeDishNumber/8": "pocet-hostu/8",
  "productTheme": "vyrobek",
  "productTheme/ACC": "vyrobek/priloha",
  "productTheme/BEA": "vyrobek/fazole",
  "productTheme/BIS": "vyrobek/fazole-s-omackou",
  "productTheme/BIO": "vyrobek/bio",
  "productTheme/CAN": "vyrobek/konzerva",
  "productTheme/CER": "vyrobek",
  "productTheme/CLS": "vyrobek/tradicni",
  "productTheme/DLE": "vyrobek/zelenina",
  "productTheme/EDR": "vyrobek/dochucovadlo",
  "productTheme/ENT": "vyrobek/predkrm",
  "productTheme/FRZ": "vyrobek/mrazeny",
  "productTheme/FSD": "vyrobek/salaty",
  "productTheme/FSH": "vyrobek",
  "productTheme/ING": "vyrobek/prisady-pro-me-recepty",
  "productTheme/JAR": "vyrobek",
  "productTheme/LBW": "vyrobek",
  "productTheme/LDF": "vyrobek/zelenina-v-troube",
  "productTheme/LEG": "vyrobek/lusteniny",
  "productTheme/LGO": "vyrobek/legumio",
  "productTheme/LGR": "vyrobek/grilovana-zelenina",
  "productTheme/LGS": "vyrobek",
  "productTheme/MAI": "vyrobek",
  "productTheme/MUS": "vyrobek/zampiony",
  "productTheme/NEW": "vyrobek/nove-produkty",
  "productTheme/PDH": "vyrobek/susena-zelenina-na-taliri",
  "productTheme/PDL": "vyrobek/kosik-zeleniny",
  "productTheme/PHR": "vyrobek/testoviny",
  "productTheme/PLP": "vyrobek",
  "productTheme/RAL": "vyrobek/ryze-a-zelenina",
  "productTheme/RDM": "vyrobek/kuchynske-talire",
  "productTheme/SAL": "vyrobek/vse-pro-me-salaty",
  "productTheme/SDB": "vyrobek/salatove-misy",
  "productTheme/SNK": "vyrobek/svacina",
  "productTheme/SUP": "vyrobek/polevky",
  "productTheme/TEX": "vyrobek/mexicka",
  "productTheme/VGP": "vyrobek/rostlinne-produkty",
  "recipeTheme": "tematicky-recepty",
  "recipeTheme/01": "tematicky-recepty/slavnosti-recepty",
  "recipeTheme/02": "tematicky-recepty/aperitiv",
  "recipeTheme/03": "tematicky-recepty/salaty-a-svaciny",
  "recipeTheme/04": "tematicky-recepty/polevky-a-kremy",
  "recipeTheme/05": "tematicky-recepty/kis-a-zapekane-recepty",
  "recipeTheme/06": "tematicky-recepty/specialne-pro-deti",
  "recipeTheme/07": "tematicky-recepty/dezerty",
  "recipeTheme/08": "tematicky-recepty/vegetarianske",
  "recipeTheme/09": "tematicky-recepty/priloha",
  "recipeTheme/10": "tematicky-recepty/rychlovky",
  "recipeTheme/11": "tematicky-recepty/varene",
  "recipeTheme/12": "tematicky-recepty/salaty-a-barbecue",
  "recipeTheme/13": "tematicky-recepty/lehke-obcerstveni",
  "recipeTheme/14": "tematicky-recepty/hlavni-jidla",
  "recipeTheme/15": "tematicky-recepty/zakusky-a-pecivo",
  "recipeTheme/16": "tematicky-recepty",
  "recipeTheme/17": "tematicky-recepty/salaty",
  "recipeTheme/18": "tematicky-recepty/misy",
  "recipeTheme/19": "tematicky-recepty/polevky",
  "recipeTheme/20": "tematicky-recepty/svacina",
  "recipeTheme/21": "tematicky-recepty/omacka",
  "recipeTheme/22": "tematicky-recepty/jednochodove",
  "recipeTheme/23": "tematicky-recepty/vicechodove",
  "recipeTheme/24": "tematicky-recepty/pecene",
  "recipeTheme/25": "tematicky-recepty",
  "recipeTheme/26": "tematicky-recepty",
  "recipeTheme/27": "tematicky-recepty",
  "recipeTheme/28": "tematicky-recepty",
  "recipeTheme/33": "tematicky-recepty",
  "recipeTheme/34": "tematicky-recepty",
  "recipeTheme/35": "tematicky-recepty",
  "recipeTheme/36": "tematicky-recepty",
  "recipeTheme/37": "tematicky-recepty",
  "recipeTheme/38": "tematicky-recepty",
  "recipeTheme/39": "tematicky-recepty",
  "recipeTheme/40": "tematicky-recepty",
  "recipeTheme/41": "tematicky-recepty",
  "recipeTheme/42": "tematicky-recepty",
  "recipeTheme/43": "tematicky-recepty",
  "recipeTheme/44": "tematicky-recepty",
  "recipeTheme/45": "tematicky-recepty",
  "recipeTheme/46": "tematicky-recepty",
  "pred-particularite": "recipe-habits",
  "pred-particularite/Sans%20conservateur": "food-habits/bez-konzervantu",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "food-habits",
  "pred-particularite/Sans%20colorant": "food-habits/bez-barviva",
  "pred-particularite/Sans%20sucre%20ajout%E9": "food-habits/ber-pridaneho-cukru",
  "pred-particularite/Sans%20sel%20ajout%E9": "food-habits/bez-pridane-soli",
  "pred-particularite/Sans%20additif": "food-habits/bez-prisad",
  "pred-particularite/": "food-habits/s-prirodni-soli",
  "pred-particularite/Sans%20lactose": "food-habits/bez-laktozy",
  "pred-particularite/Sans%20gluten": "food-habits/bez-lepku",
  "pred-particularite/V%E9g%E9tarien": "food-habits/vegetarianske",
  "pred-particularite/V%E9g%E9talien": "food-habits/veganske",
  "pred-particularite/Sans%20sulfite": "food-habits",
  "pred-particularite/A%20la%20vapeur": "food-habits",
  "pred-particularite/Sans%20condiment": "food-habits",
  "cultureType": "typ-plodiny",
  "cultureType/Bio": "typ-plodiny/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "typ-plodiny/bez-pesiticdu",
  "cultureType/Sans%20OGM": "typ-plodiny/bez-gmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "recipe-habits/vegansky",
  "pred-particularite/recipeVeggie": "recipe-habits/vegetariansky",
  "pred-particularite/recipeGlutenfree": "recipe-habits/bez-lepku",
  "pred-particularite/recipeLactosefree": "recipe-habits/bez-laktozy"
};
